import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchGiftCard } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
// import ViewGiftCard from '../components/giftCards/ViewGiftCard';
import EditGiftCard from '../components/giftCards/EditGiftCard';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  giftcards: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class GiftCardEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchGiftCard(this.props.params.id));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="giftcard component" style={authPage}>
        <h2>Edit Gift Card</h2>
        <div className="content">
          <EditGiftCard
            giftcard={this.props.giftcards.giftcard}
          />
        </div>
      </div>
    );
  }
}

GiftCardEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

GiftCardEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    giftcards: state.giftCards,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(GiftCardEditPage));



// WEBPACK FOOTER //
// ./src/containers/GiftCardEditPage.js